import gql from 'graphql-tag';

export default gql`
    query isKlarnaPaymentAvailable {
        storeConfig {
            is_klarna_payment_enabled
        }
    }
`;
